export enum SalonStatus {
  TRIAL = 'trial',
  TRIAL_EXPIRED = 'trialExpired',
  SUBSCRIBED = 'subscribed',
  SUBSCRIPTION_EXPIRED = 'subscriptionExpired',
  SUBSCRIPTION_CANCELLED = 'subscriptionCancelled',
  SUSPENDED = 'suspended',
}
